<template>
  <div>
    <v-navigation-drawer
      app
      v-model="drawer.open"
      right
      temporary
    >
      <v-list
        nav
      >
        <v-list-item
          link
          @click="openAbout()"
        >
          <v-list-item-icon>
            <v-icon>
              mdi-information
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              About
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  mapState,
} from 'vuex'

export default {
  name:'Menu',
  data(){
    return {
    }
  },
  computed: {
    ...mapState(
      [
        'drawer'
      ]
    )
  },
  methods: {
    openAbout() {
      this.$router.push(
        {
         'name':'About'
        }
      )
    }
  }
}
</script>
